
import { useAuthGuard } from "@/hooks/useAuthGuard";
import { useNavigate } from "react-router-dom";
import EmptyResumes from "../EmptyResumes";
import ResumeSearchBar from "../search/ResumeSearchBar";
import ResumeList from "../list/ResumeList";
import { filterResumes, sortResumes } from "../utils/resumeUtils";
import { useState, useEffect } from "react";

interface ResumeContentProps {
  resumes: any[];
  onCreateTest: () => void;
  onPreview: (resume: any) => void;
  onDownload: (resume: any) => void;
  onDelete: (resume: any) => void;
}

const ResumeContent = ({ 
  resumes,
  onCreateTest,
  onPreview,
  onDownload,
  onDelete
}: ResumeContentProps) => {
  const { user } = useAuthGuard();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [sortBy, setSortBy] = useState<string>("newest");
  const [loading, setLoading] = useState(false);

  const filteredResumes = sortResumes(
    filterResumes(resumes, searchQuery, statusFilter),
    sortBy
  );
  
  useEffect(() => {
    setLoading(false);
  }, [resumes]);

  if (!user) {
    return (
      <EmptyResumes 
        isAuthenticated={false}
        onLogin={() => navigate("/auth/login")}
        onCreateTest={onCreateTest}
      />
    );
  }

  if (resumes.length === 0) {
    return (
      <EmptyResumes 
        isAuthenticated={true}
        onCreateTest={onCreateTest}
      />
    );
  }

  return (
    <>
      <ResumeSearchBar
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
        sortBy={sortBy}
        onSortChange={setSortBy}
      />
      
      <ResumeList
        resumes={filteredResumes}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        onPreview={onPreview}
        onDownload={onDownload}
        onDelete={onDelete}
        loading={loading}
      />
    </>
  );
};

export default ResumeContent;
